export const notificationBannerInitialState = [];

export const SHOW_SUCCESS_BANNER = "SHOW_SUCCESS_BANNER";
export const SHOW_ERROR_BANNER = "SHOW_ERROR_BANNER";
export const SHOW_INFO_BANNER = "SHOW_INFO_BANNER";
export const SHOW_WARNING_BANNER = "SHOW_WARNING_BANNER";
export const HIDE_BANNER = "HIDE_BANNER";

const createBanner = (state, bannerType, bannerMessage) => {
    return [...state, { bannerId: Date.now(), showBannerAlert: true, bannerType, bannerMessage }]
}

const closeBanner = (state, bannerId) => {
    return state?.filter(banner => banner.bannerId !== bannerId)
}

export const notificationBannerReducer = (state, { type, bannerMessage, bannerId }) => {
    switch (type) {
        case HIDE_BANNER:
            return [...closeBanner(state, bannerId)];
        case SHOW_ERROR_BANNER:
            return { ...state, bannerType: SHOW_ERROR_BANNER, showBannerAlert: true, bannerMessage: bannerMessage || "" };
        case SHOW_SUCCESS_BANNER:
            return [...createBanner(state, SHOW_SUCCESS_BANNER, bannerMessage)];
        case SHOW_INFO_BANNER:
            return { ...state, bannerType: SHOW_INFO_BANNER, showBannerAlert: true, bannerMessage: bannerMessage || "" };
        case SHOW_WARNING_BANNER:
            return { ...state, bannerType: SHOW_WARNING_BANNER, showBannerAlert: true, bannerMessage: bannerMessage || "" };
        default:
            return state;
    }
};
